import {keepPreviousData, useQuery} from '@tanstack/react-query'
import {useShowError} from '@hooks/useShowError/useShowError'
import {getConnectedMikrotikApi} from '@containers/equipment/mikrotik/api/api'

export const QUERY_KEY_CONNECTED_MIKROTIK = 'connected-mikrotik'

export const useConnectedMikrotikQuery = () => {

	const {onShowError} = useShowError()

	return useQuery({
		queryFn: () => getConnectedMikrotikApi(onShowError),
		queryKey: [QUERY_KEY_CONNECTED_MIKROTIK],
		staleTime: 1000 * 60,
		placeholderData: keepPreviousData,
	})
}
